/* eslint-disable jsx-a11y/label-has-associated-control */
import { ChangeEvent, FormEvent } from "react";

import { Button, FileInput, Spinner } from "@ezmid/components-library";
import { Control, FieldErrors, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { FormInputField } from "../../../components/hookFormComponents/FormInputField";
import { TextareaField } from "../../../components/hookFormComponents/TextareaField";
import { Tabs } from "../../../components/tabs/Tabs";

const DEFAULT_IMAGE = "/avatar.svg";

type Props<T extends FieldValues> = {
  handleSubmit: (event: FormEvent<HTMLFormElement>) => void;
  control: Control<T>;
  errors: FieldErrors;
  lecturerImage: string;
  onChangePicture: (e: ChangeEvent<HTMLInputElement>) => void;
  isImageLoading: boolean;
  isSubmitButtonDisabled: boolean;
  onSumbit: () => void;
};

export function LecturerDetailForm<T extends FieldValues>({
  handleSubmit,
  control,
  errors,
  lecturerImage,
  onChangePicture,
  isImageLoading,
  isSubmitButtonDisabled,
  onSumbit,
}: Props<T>) {
  const { t } = useTranslation();

  const tabsData = [
    {
      label: `${t("form.description.label")} EN`,
      content: (
        <TextareaField
          key="descriptionEN"
          name="descriptionEN"
          htmlFor="descriptionEN"
          id="descriptionEN"
          control={control}
          error={errors.descriptionEN}
          placeholder={t("form.description.label")}
        />
      ),
    },
    {
      label: `${t("form.description.label")} DE`,
      content: (
        <TextareaField
          key="descriptionDE"
          name="descriptionDE"
          htmlFor="descriptionDE"
          id="descriptionDE"
          control={control}
          error={errors.descriptionDE}
          placeholder={t("form.description.label")}
        />
      ),
    },
  ];

  return (
    <div className="flex flex-col">
      <form onSubmit={handleSubmit} />
      <div className="flex w-full min-w-full px-4 pt-4">
        <div className="flex justify-center items-center w-3/12">
          {!isImageLoading ? (
            <div className="flex flex-col w-full min-w-full justify-center pr-2 pt-2">
              <img
                src={lecturerImage || DEFAULT_IMAGE}
                alt="profile"
                className="rounded-md h-52 object-cover"
              />
            </div>
          ) : (
            <div className="flex justify-center min-w-full">
              <Spinner
                isLoading={isImageLoading}
                type="fadeLoader"
                size="20"
                color="#38bdf8"
              />
            </div>
          )}
        </div>
        <div className="w-3/4">
          <FormInputField
            name={"fullName" as any}
            htmlFor="fullName"
            label={t("form.fullname")}
            id="fullName"
            type="text"
            control={control}
            error={errors.fullName}
            placeholder={t("form.fullname")}
          />
          <FormInputField
            name={"email" as any}
            htmlFor="email"
            label={t("form.email.label")}
            id="email"
            type="text"
            control={control}
            error={errors.email}
            placeholder="email@email.com"
          />
          <div className="pt-2">
            <label className="block font-normal tmb-1 text-gray-500">
              {t("form.label.upload.picture")}
            </label>
            <FileInput inputSize="md" onChange={onChangePicture} />
          </div>
        </div>
      </div>
      <div className="px-4">
        <Tabs tabsData={tabsData} />
      </div>
      <div className="pb-2 pr-4 flex justify-end">
        <Button onClick={onSumbit} disabled={isSubmitButtonDisabled}>
          {t("button.save")}
        </Button>
      </div>
    </div>
  );
}
